
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { AreaAdmin, ConversaUsaurio } from '../../models/area';
import { Mensagem, OrigemMensagem } from '../../models/mensagem';

@Injectable()
export class AreaAdminLocalProvider {

  private _$areas: BehaviorSubject<AreaAdmin[]>;
  public readonly limiteDeMensagens = 50;
  public readonly limiteDeConversas = 15;

  constructor() {
    this._$areas = new BehaviorSubject<AreaAdmin[]>([]);
  }

  public get $areas() {
    return this._$areas.asObservable();
  }

  public updateArea(area: AreaAdmin): void {
    const areas = this.getAreas();
    for (let i = 0, len = areas.length; i < len; i++) {
      if (areas[i].idArea === area.idArea) {
        areas[i] = area
        break;
      }
    }
    this.setAreas(areas);
  }

  public setAreas(areas: AreaAdmin[]): void {
    localStorage.setItem('areasAdmin', JSON.stringify(areas));
    this._$areas.next(areas);
  }

  public marcarMensagensLidas(idArea: number, idUsuario: number): void {
    const area = this.getArea(idArea);
    if (area && area.conversasUsuarios) {
      const i = area.conversasUsuarios.findIndex(c => c.idUsuario === idUsuario)
      for (const mensagem of area.conversasUsuarios[i].mensagens) {
        if (mensagem.podeSerRespondida) {
          mensagem.statusMensagemLida = true;
          mensagem.statusMensagemRecebida = true;
        }
      }
      this.updateArea(area);
    }
    this.marcarMensagensGeraisUsuarioLidas(idArea, idUsuario)
  }

  private marcarMensagensGeraisUsuarioLidas(idArea: number, idUsuario: number): void {
    const area = this.getArea(idArea);
    if (area && area.mensagensGerais) {
      for (const mensagem of area.mensagensGerais) {
        if (mensagem.idUsuarioOrigem === idUsuario) {
          mensagem.statusMensagemLida = true;
          mensagem.statusMensagemRecebida = true;
        }
      }
      this.updateArea(area);
    }
  }

  public marcarMensagensGeraisLidas(idArea: number): void {
    const area = this.getArea(idArea);
    if (area && area.mensagensGerais) {
      for (const mensagem of area.mensagensGerais) {
        // se for enviada por um usuário comum ou é do sistema
        if (mensagem.podeSerRespondida || !mensagem.idUsuarioOrigem) {
          mensagem.statusMensagemLida = true;
          mensagem.statusMensagemRecebida = true;
        }
      }
      this.updateArea(area);
    }
    this.marcarTodasMensagensConversaUsuarioLidas(idArea);
  }

  private marcarTodasMensagensConversaUsuarioLidas(idArea: number): void {
    const area = this.getArea(idArea);
    if (area && area.conversasUsuarios) {
      for (const conversaUsuario of area.conversasUsuarios) {
        // se for enviada por um usuário comum ou é do sistema
        for (const m of conversaUsuario.mensagens) {
          if (m.podeSerRespondida) {
            m.statusMensagemLida = true;
            m.statusMensagemRecebida = true;
          }
        }
      }
      this.updateArea(area);
    }
  }

  public setMensagensArea(idArea: number, mensagens: Mensagem[]): void {
    /*  const area = this.getArea(idArea);
      if (area) {
          area.mensagens = mensagens;
          this.updateArea(area);
      } */
  }

  // adicionar a mensagem na geral e na conversa
  public adicionarNovaMensagemGeral(idArea: number, mensagem: Mensagem) {
    // se foi enviada por um usuári
    if (mensagem.idUsuarioOrigem) {
      // se foi para um usuário especifico
      if (mensagem.idUsuarioDestino) {
        this._adicionarNovaMensagem(idArea, mensagem.idUsuarioDestino, mensagem);
      } else {
        // se foi para todos os usuários
        this.adicionarNovaMensagemTodasConversas(idArea, mensagem);
      }
    }
    const area = this.getArea(idArea);
    if (!area.mensagensGerais) {
      area.mensagensGerais = [];
    }
    area.mensagensGerais.push(mensagem);
    this.updateArea(area);
  }

  // só adiciona a mensagem na geral
  private _adicionarNovaMensagemGeral(idArea: number, mensagem: Mensagem) {
    const area = this.getArea(idArea);
    if (!area.mensagensGerais) {
      area.mensagensGerais = [];
    }
    area.mensagensGerais.push(mensagem);
    this.updateArea(area);
  }

  // adiciona mensagem na geral e na conversa
  public adicionarNovaMensagem(idArea: number, idUsuario: number, mensagem: Mensagem) {
    this._adicionarNovaMensagemGeral(idArea, mensagem);
    const area = this.getArea(idArea);
    if (area.conversasUsuarios) {
      const i = area.conversasUsuarios.findIndex(c => c.idUsuario === idUsuario);
      if (i !== -1) {
        area.conversasUsuarios[i].mensagens.push(mensagem);
        this.updateArea(area);
      }
    }
  }

  // só adiciona a mensagem na conversa
  private _adicionarNovaMensagem(idArea: number, idUsuario: number, mensagem: Mensagem) {
    const area = this.getArea(idArea);
    if (area.conversasUsuarios) {
      const i = area.conversasUsuarios.findIndex(c => c.idUsuario === idUsuario);
      if (i !== -1) {
        area.conversasUsuarios[i].mensagens.push(mensagem);
        this.updateArea(area);
      }
    }
  }

  private adicionarNovaMensagemTodasConversas(idArea: number, mensagem: Mensagem) {
    const area = this.getArea(idArea);
    if (area.conversasUsuarios) {
      for (const c of area.conversasUsuarios) {
        c.mensagens.push(mensagem);
      }
      this.updateArea(area);
    }
  }

  public removerConversaContatoAcimaDoLimite(idArea: number): void {
    const area = this.getArea(idArea);
    if (area && area.conversasUsuarios.length > this.limiteDeConversas) {
      area.conversasUsuarios.sort(
        (a, b) => {
          let timeA = 0;
          let timeB = 0;
          if (a.mensagens && a.mensagens.length > 0) {
           timeA = a.mensagens[a.mensagens.length - 1].dataHora
          }
          if (b.mensagens && b.mensagens.length > 0) {
            timeB = b.mensagens[b.mensagens.length - 1].dataHora
          }
          return timeB - timeA
        }
      );
      area.conversasUsuarios = area.conversasUsuarios.slice(0, this.limiteDeConversas);
      this.updateArea(area);
    }
  }

  public removerMensagensGeraisAcimaDoLimite(idArea: number): void {
    const area = this.getArea(idArea);
    if (area && area.mensagensGerais.length > this.limiteDeMensagens) {
      area.mensagensGerais = area.mensagensGerais.slice(-this.limiteDeMensagens);
      this.updateArea(area);
    }
  }

  public removerMensagensAcimaDoLimite(idArea: number, idUsuario: number): void {
    const area = this.getArea(idArea);
    if (area && area.conversasUsuarios) {
      const i = area.conversasUsuarios.findIndex(c => c.idUsuario === idUsuario);
      if (area.conversasUsuarios[i].mensagens.length > this.limiteDeMensagens) {
        area.conversasUsuarios[i].mensagens = area.conversasUsuarios[i].mensagens.slice(-this.limiteDeMensagens);
        this.updateArea(area);
      }
    }
  }

  public marcarMensagemRecebida(mensagem: Mensagem): void {
    const area = this.getArea(mensagem.idArea);
    if (area && area.conversasUsuarios) {
      const i = area.conversasUsuarios.findIndex(c => c.idUsuario === mensagem.idUsuarioOrigem)
      for (const m of area.conversasUsuarios[i].mensagens) {
        if (m.idEnvio && m.idEnvio === mensagem.idEnvio) {
          m.statusMensagemRecebida = true;
          break
        }
      }
      this.updateArea(area);
    }
  }

  public marcarMensagemGeralRecebida(mensagem: Mensagem): void {
    const area = this.getArea(mensagem.idArea);
    if (area && area.mensagensGerais) {
      for (const m of area.mensagensGerais) {
        if (m.idEnvio && m.idEnvio === mensagem.idEnvio) {
          m.statusMensagemRecebida = true;
          break
        }
      }
      this.updateArea(area);
    }
  }

  public getMensagensComRecebimentoPendente(): Mensagem[] {
    return [];
    /*    const areas = this.getAreas();
      if (areas) {
          let mensagensComNotificacaoDeRecebimentoPendente = []
          for (const area of areas) {
              for (const mensagem of area.mensagens) {
                  if (!mensagem.statusMensagemRecebida) {
                      mensagensComNotificacaoDeRecebimentoPendente.push(mensagem);
                  }
              }
          }
          return mensagensComNotificacaoDeRecebimentoPendente;
      }*/
  }

  public atualizarMensagemGeral(idArea: number, m: Mensagem): void {
    const area = this.getArea(idArea);
    if (area) {
      // a pesquisa é invertida pois é provavel que a mensagem esteja no fim
      for (let i = area.mensagensGerais.length - 1; i >= 0; i--) {
        const mensagem = area.mensagensGerais[i];
        if (mensagem.idEnvio && mensagem.idEnvio === m.idEnvio) {
          area.mensagensGerais[i] = m
          break;
        }
      }
      this.updateArea(area);
    }
  }

  public atualizarMensagem(idArea: number, idUsuario: number, m: Mensagem): void {
    const area = this.getArea(idArea);
    if (area) {
      const i = area.conversasUsuarios.findIndex(c => c.idUsuario === idUsuario);
      // a pesquisa é invertida pois é provavel que a mensagem esteja no fim
      for (let j = area.conversasUsuarios[i].mensagens.length - 1; j >= 0; j--) {
        const mensagem = area.conversasUsuarios[i].mensagens[j];
        if (mensagem.idEnvio && mensagem.idEnvio === m.idEnvio) {
          area.conversasUsuarios[i].mensagens[j] = m
          break;
        }
      }
      this.updateArea(area);
    }
  }

  public atualizarMensagemGeralEnviada(idArea: number, idEnvioLocal: number, idEnvio: number): void {
    const area = this.getArea(idArea);
    if (area && area.mensagensGerais) {
      // a pesquisa é invertida pois é provavel que a mensagem esteja no fim
      for (let i = area.mensagensGerais.length - 1; i >= 0; i--) {
        const mensagem = area.mensagensGerais[i];
        if (mensagem.idEnvio && mensagem.idEnvio === idEnvioLocal) {
          mensagem.idEnvio = idEnvio;
          mensagem.pendente = false;
          break;
        }
      }
      this.updateArea(area);
    }
  }

  public atualizarMensagemEnviada(idArea: number, idUsuario: number, idEnvioLocal: number, idEnvio: number): void {
    const area = this.getArea(idArea);
    if (area) {
      const i = area.conversasUsuarios.findIndex(c => c.idUsuario === idUsuario);
      // a pesquisa é invertida pois é provavel que a mensagem esteja no fim
      for (let j = area.conversasUsuarios[i].mensagens.length - 1; j >= 0; j--) {
        const mensagem = area.conversasUsuarios[i].mensagens[j];
        if (mensagem.idEnvio && mensagem.idEnvio === idEnvioLocal) {
          mensagem.idEnvio = idEnvio
          mensagem.pendente = false;
          break;
        }
      }
      this.updateArea(area);
    }
  }

  public adicionarConversaUsuario(idArea: number, conversaUsuario: ConversaUsaurio): void {
    const area = this.getArea(idArea);
    if (area) {
      if (!area.conversasUsuarios) {
        area.conversasUsuarios = [];
      }
      // caso a conversa do usuário já existir, não adicione ela
      if (area.conversasUsuarios.findIndex(c => c.idUsuario === conversaUsuario.idUsuario) > -1) {
        return
      }
      area.conversasUsuarios.push(conversaUsuario);
      this.updateArea(area);
    }
  }

  public setAreasUsuarios(usuarios: any[]): void {
    this.setAreas(usuarios[0].Areas);
  }

  public getArea(idArea): AreaAdmin | undefined {
    return this.getAreas().find(a => a.idArea == idArea);
  }

  public hasArea(idArea): boolean {
    return this.getAreas().some(a => a.idArea == idArea);
  }

  public getConversaUsuario(idArea: number, idUsuario: number): ConversaUsaurio {
    const area = this.getArea(idArea);
    if (area) {
      return area.conversasUsuarios.find(c => c.idUsuario === idUsuario);
    }
  }

  public getAreas(): AreaAdmin[] {
    if (localStorage.getItem('areasAdmin')) {
      return JSON.parse(localStorage.getItem('areasAdmin'));
    }
    return [];
  }
}



// WEBPACK FOOTER //
// ./src/providers/area-admin-local/area-admin-local.ts